import Swiper from "swiper";
import ekkoLightbox from "ekko-lightbox";
import vide from "vide";
import 'select2';


const plg = require("../autoload/functions-comunes");
export default {
  init() {
    // JavaScript to be fired on all pages
    setTimeout(function () {
      $('#loading').fadeOut(function () {
        $(this).remove();
      });
    }, 400);
    $('.collapse').collapse();
    if ($('.swiper-test')) {
      var swiper_test = new Swiper(".swiper-test", {
        cssMode: true,
        simulateTouch: false,
        slidesPerView: 1,
        autoHeight: true,
        observer: true,
        on: {
          init: function () {
            // console.log('swiper initialized');
          },
          transitionStart: function () {
            // console.log('slide change start - before');
            // console.log(swiperPasos.activeIndex);
          },
          transitionEnd: function () {
            // console.log('slide change end - after');
            // console.log(swiperPasos.activeIndex);
          }
        }
      });
    }

    $('.js-contacto').on('click', function (e) {
      var error = false;
      var form = document.getElementById('fContacto');
      var formJS = $('#fContacto');
      formJS.find('.alert .items-invalid').html("");
      var nombre = document.getElementById('nombre');
      var email = document.getElementById('email');
      var mensaje = document.getElementById('mensaje');

      var checklegal1 = document.getElementById('ckcontacto');
      if (form.checkValidity() === false) {
        error = true;
        if (!nombre.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, introduce tu nombre para que podamos dirigirnos a ti.</li>");
        if (!email.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, introduce un email con formato correcto.</li>");
        if (mensaje) {
          if (!mensaje.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, introduce tu mensaje.</li>");
        }
        if (!checklegal1.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, acepta la <a href='/politica-privacidad' target='_blank'>política de privacidad</a>.</li>");
      }
      formJS.addClass('was-validated');
      if (!error) {
        formJS.find('.alert').slideUp("fast");
        // var datos = formJS.serialize();
        var datos = new FormData(document.querySelector('#fContacto'));
        if ($('#archivo_adjunto').length) {
          datos.append('archivo_adjunto', $('#archivo_adjunto')[0].files[0]);
        }
        $.ajax({
          method: "POST",
          url: window.global.ajax_url,
          data: datos,
          contentType: false,
          processData: false,
          dataType: "json"
        })
          .done(function (msg) {

            if (msg.respuesta == "KO") {
              plg.PLG_showModalAlerta(msg.titulo, msg.texto)
            } else {
              formJS[0].reset();
              if (msg.next == "") {
                plg.PLG_showModalAlerta('REDPISO', 'Mensaje enviado correctamente.')
              } else {
                self.location.href = msg.next;
              }
            }

          });
      } else {
        formJS.find('.alert').slideDown(function () { });
        plg.PLG_scrollTo(0.5, ".section-contacto", 0, 0);
      }
      e.preventDefault(e);
    });

    $('.js-test1').on('click', function (e) {
      var error = false;
      var form = document.getElementById('fTest1');
      var formJS = $('#fTest1');
      formJS.find('.alert .items-invalid').html("");
      var nombre = document.getElementById('nombre');
      var email = document.getElementById('email');
      var apellidos = document.getElementById('apellidos');

      var checklegal1 = document.getElementById('ckcontacto');
      if (form.checkValidity() === false) {
        error = true;
        if (!nombre.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, introduce tu nombre para que podamos dirigirnos a ti.</li>");
        if (!apellidos.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, introduce tus apellidos para que podamos dirigirnos a ti.</li>");
        if (!email.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, introduce un email con formato correcto.</li>");
        if (!checklegal1.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, acepta la <a href='/politica-privacidad' target='_blank'>política de protección de datos</a> y la <a href='/politica-privacidad' target='_blank'>política de privacidad</a>.</li>");
      }
      formJS.addClass('was-validated');
      if (!error) {
        formJS.find('.alert').slideUp("fast");

        if ($(this).closest(".section-test").find(".js-hayInstrucciones").length == 0) {
          pintarBarra(1);
        }

        swiper_test.slideTo(1, 1000, false);
      } else {
        formJS.find('.alert').slideDown(function () { });
        plg.PLG_scrollTo(0.5, ".section-test", 0, 0);
      }
      e.preventDefault(e);
    });

    $('.js-respuesta').on('click', function () {
      $(this).closest('.swiper-slide').find('.js-respuesta').removeClass('activa');
      $(this).addClass('activa');

      var _txtsel = $(this).attr('data-respuesta');
      var _correcta = $(this).attr('data-correcta');
      if (_correcta == '') {
        _correcta = 0;
      }
      $(this).closest('.div-respuestas').find('p').removeClass('seleccion');
      $(this).find('p').addClass('seleccion');
      var _pregunta = $(this).attr('data-pregunta');
      $('#respuesta-' + _pregunta).val(_txtsel);
      $('#respuesta-' + _pregunta).attr('data-correcta', _correcta);
      $('#resultado-' + _pregunta).val(_correcta);

      $('#total-acertadas').val($('.js-resp[data-correcta="1"]').length);
      $('#total-falladas').val($('.js-resp[data-correcta="0"]').length);
    });

    $('.js-testAnterior').on('click', function () {
      swiper_test.slidePrev();
    });

    $(".js-testInstruccioknes").on('click', function () {
      pintarBarra(1);
      swiper_test.slideNext();
    });

    $('.js-testSiguiente').on('click', function () {
      swiper_test.slideNext();
    });

    $('.js-test2').on('click', function () {
      var _paso = $(this).attr('data-pasoAct');
      $('#fTest1').find('.alert').slideUp("fast");


      if ($('#respuesta-' + _paso).val() == '') {
        $('#fTest1').find('.alert .items-invalid').html("<li>Por favor, selecciona una respuesta.</li>");
        $('#fTest1').find('.alert').slideDown(function () { });
        plg.PLG_scrollTo(0.5, ".section-test", 0, 0);
      } else {
        $('#total_acertado').html($('#total-acertadas').val());
        $('#total_fallado').html($('#total-falladas').val());
        $('.txtsup').hide();
        $('.txtinf').hide();
        //if (parseInt($('#total-acertadas').val()) > parseInt($('#total-falladas').val())){
        var _total = parseInt($('#total-acertadas').val()) + parseInt($('#total-falladas').val());
        var _pc = _total * 0.7;

        if (parseInt($('#total-acertadas').val()) >= _pc) {
          $('#texto_sup_resultado_superado').show();
          $('#texto_inf_resultado_superado').show();
        } else {
          $('#texto_sup_resultado_fallado').show();
          $('#texto_inf_resultado_fallado').show();
        }
        pintarBarra(_paso);

        if ($(this).closest(".section-test").find(".js-hayInstrucciones").length > 0) {
          swiper_test.slideTo(parseInt(_paso, 10) + 1, 1000, false);
        } else {
          swiper_test.slideTo(parseInt(_paso, 10), 1000, false);
        }


      }
    });

    $('.js-test3').on('click', function () {

      //Tengo que hacer esto porque de lo contrario el recaptcha ha caducado.
      console.log("cargo recaptcha");
      if (getRecaptchaValor()) {
        console.log("OK carga recaptcha");
      }
      //Doy tiempo para que cambie el dom porque se adelanta y manda lo que no es.
      setTimeout(function () {

        var datos = new FormData(document.querySelector('#fTest1'));

        $.ajax({
          method: "POST",
          url: window.global.ajax_url,
          data: datos,
          contentType: false,
          processData: false,
          dataType: "json"
        })
          .done(function (msg) {

            if (msg.respuesta == "KO") {
              plg.PLG_showModalAlerta(msg.titulo, msg.texto);
            } else {
              $('#fTest1')[0].reset();
              plg.PLG_showModalAlerta('¡ENHORABUENA!', 'Tus respuestas se han guardado con éxito');
            }

          });

      }, 300);

    });

    function pintarBarra(pasosw) {
      var _total_preguntas = $('#total-preguntas').val();
      var pctje = 0;
      $('.barra-pctje').show();
      pctje = (parseInt(pasosw - 1)) * 100 / parseInt(_total_preguntas);
      if (_total_preguntas == pasosw) {
        $('.barra-gris').hide
      }

      if (pctje > 100) {
        pctje = 100;
      }

      $('.barra-roja').css('width', pctje + '%');
      $('.txtbarra').removeClass('activo');
      if (pctje >= 25) {
        $('.txt25').removeClass('inactivo');
        $('.txt25').addClass('activo');
      }
      if (pctje >= 50) {
        $('.txt50').removeClass('inactivo');
        $('.txt50').addClass('activo');
      }
      if (pctje >= 75) {
        $('.txt75').removeClass('inactivo');
        $('.txt75').addClass('activo');
      }
      if (pctje >= 100) {
        $('.txt100').removeClass('inactivo');
        $('.txt100').addClass('activo');

      }


    }

    function matchStart(params, data) {
      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }

      // Skip if there is no 'children' property
      if (typeof data.children === 'undefined') {
        return null;
      }

      // `data.children` contains the actual options that we are matching against
      var filteredChildren = [];
      $.each(data.children, function (idx, child) {
        if (child.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
          filteredChildren.push(child);
        }
      });

      // If we matched any of the timezone group's children, then set the matched children on the group
      // and return the group object
      if (filteredChildren.length) {
        var modifiedData = $.extend({}, data, true);
        modifiedData.children = filteredChildren;

        // You can return modified objects from here
        // This includes matching the `children` how you want in nested data sets
        return modifiedData;
      }

      // Return `null` if the term should not be displayed
      return null;
    }


    $('.js-select2').select2({
      multiple: true,
      placeholder: 'Selecciona ...',
      matcher: matchStart
    });

    $('.js-captacion').on('click', function (e) {
      var error = false;
      var form = document.getElementById('fCaptacion');
      var formJS = $('#fCaptacion');
      formJS.find('.alert .items-invalid').html("");
      var nombre = document.getElementById('nombre');
      var email = document.getElementById('email');
      var oficina = document.getElementById('oficina');
      var cv = document.getElementById('cv');

      var checklegal1 = document.getElementById('ckcontacto');
      if (form.checkValidity() === false) {
        error = true;
        if (!nombre.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, introduce tu nombre para que podamos dirigirnos a ti.</li>");
        if (!email.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, introduce un email con formato correcto.</li>");
        if (!oficina.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, selecciona una oficina.</li>");
        if (!cv.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, elige tu curriculum vitae.</li>");
        if (!checklegal1.validity.valid) formJS.find('.alert .items-invalid').append("<li>Por favor, acepta la <a href='/politica-privacidad' target='_blank'>política de privacidad</a>.</li>");
      }
      formJS.addClass('was-validated');
      if (!error) {
        formJS.find('.alert').slideUp("fast");
        //  var datos = formJS.serialize();
        var datos = new FormData(document.querySelector('#fCaptacion'));
        datos.append('cv_file', $('#cv')[0].files[0]);


        $.ajax({
          method: "POST",
          url: window.global.ajax_url,
          data: datos,
          contentType: false,
          processData: false,
          dataType: "json"
        })
          .done(function (msg) {
            if (msg.respuesta == "KO") {
              plg.PLG_showModalAlerta(msg.titulo, msg.texto)
            } else {
              formJS[0].reset();
              if (msg.next == "") {
                plg.PLG_showModalAlerta('REDPISO', 'Mensaje enviado correctamente.')
              } else {
                self.location.href = msg.next;
              }
            }

          });
      } else {
        formJS.find('.alert').slideDown(function () { });
        plg.PLG_scrollTo(0.5, ".section-captacion", 0, 0);
      }
      e.preventDefault(e);
    });
    if ($('.swiper-horizontal')) {
      var swiper = new Swiper(".swiper-horizontal", {
        cssMode: true,
        spaceBetween: 90,
        navigation: {
          nextEl: ".swiper-button-next-horizontal",
          prevEl: ".swiper-button-prev-horizontal",
        },
        pagination: {
          el: ".swiper-pagination-horizontal",
        }
      });
    }
    if ($('.swiper-horizontal-360').length > 0) {

      var div = document.getElementById('container360');
      //var arr_images = $('#array_images').val();

      var arr_images2 = { "img_0": { "id_virtual_visit": "img_0", "area": "estancia1", "descripcion": "desc estancia 1", "url": "https:\/\/redpisolandings.plug-in.es\/wp-content\/uploads\/2021\/07\/tn_1o-PISO-SAN-CRISTOBAL-29-MARZO17155.jpg" }, "img_1": { "id_virtual_visit": "img_1", "area": "estancia2", "descripcion": "desc estancia2", "url": "https:\/\/redpisolandings.plug-in.es\/wp-content\/uploads\/2021\/07\/tn_1o-PISO-SAN-CRISTOBAL-29-MARZO17159.jpg" }, "img_2": { "id_virtual_visit": "img_2", "area": "estancia3", "descripcion": "desc estancia3", "url": "https:\/\/redpisolandings.plug-in.es\/wp-content\/uploads\/2021\/07\/tn_1o-PISO-SAN-CRISTOBAL-29-MARZO17158.jpg" }, "img_3": { "id_virtual_visit": "img_3", "area": "estancia4", "descripcion": "desc estancia4", "url": "https:\/\/redpisolandings.plug-in.es\/wp-content\/uploads\/2021\/07\/tn_1o-PISO-SAN-CRISTOBAL-29-MARZO17161.jpg" }, "img_4": { "id_virtual_visit": "img_4", "area": "estancia5", "descripcion": "desc estancia5", "url": "https:\/\/redpisolandings.plug-in.es\/wp-content\/uploads\/2021\/07\/tn_1o-PISO-SAN-CRISTOBAL-29-MARZO17156.jpg" } }

      var datos = [];
      $(".item-swiper").each(function (index) {
        datos[$(this).attr('data-id')] = { "id_virtual_visit": $(this).attr('data-id'), "area": $(this).attr('data-area'), "url": $(this).attr('data-url') };
      });

      var arr_images = datos;
      var current_image = arr_images['img_0'];
      var PSV, PSVHUD;

      initPSV();
      $('.js-swiper').on('click', function () {
        var _id = $(this).attr('data-id');
        var _sala = $(this).attr('data-area');
        //console.log('sala activa:: '+_sala);
        current_image = arr_images[_id];
        $('.js-swiper').removeClass('sw-activo');
        PSV.setPanorama(current_image['url']);
        $(this).addClass('sw-activo');
      });



      var swiper360 = new Swiper(".swiper-horizontal-360", {
        cssMode: true,
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-horizontal-360",
          prevEl: ".swiper-button-prev-horizontal-360",
        },
        pagination: {
          el: ".swiper-pagination-horizontal-360",
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          // when window width is >= 640px
          768: {
            slidesPerView: 3,
            spaceBetween: 10
          }
        }
      });
      $('#bloque-salas').slideToggle(function () {
        swiper360.update();
      });
      $(".js-mostrar").on('click', function () {
        $('#bloque-salas').slideToggle(function () {
          swiper360.update();
        });
      });
    }

    function initPSV() {
      PSV = new PhotoSphereViewer({
        panorama: current_image['url'],
        container: div,
        time_anim: false,
        default_fov: 179,
        navbar: [
          'autorotate',
          'zoom',
          'caption',
          'fullscreen'
        ],
        navbar_style: {
          backgroundColor: 'rgba(58, 67, 77, 0.7)'
        },
        cache_texture: 0
      });

      PSV.on({
        ready: function () {
          PSVHUD = PSV.hud;
        }
      });

    }

    if ($('.swiper-testimonios')) {
      var swiper = new Swiper(".swiper-testimonios", {
        cssMode: true,
        navigation: {
          nextEl: ".swiper-button-next-testimonios",
          prevEl: ".swiper-button-prev-testimonios",
        },
        pagination: {
          el: ".swiper-pagination-testimonios",
        }
      });
    }


    $("section[data-etiqueta!='']").each(function () {
      var _etiqueta = $(this).attr('data-etiqueta');
      var _href = encodeURIComponent($(this).attr('id'));
      if (_etiqueta != '' && _etiqueta != 'undefined' && _etiqueta != undefined) {
        $('.mod-sidebar .submenu').append('<a href="#' + _href + '" class="indice js-menu-ancla"><span>' + _etiqueta + "</span></a>");
      }
      $(".js-menu-ancla").click(function (e) {
        e.preventDefault();
        var ancla = $(this).attr("href");
        var offset = $(this).data("menuancla-offset");
        if (offset == "" || offset == undefined) {
          offset = 0;
        }
        plg.PLG_scrollTo(1, ancla, 0, offset, 0);
      });
    });

    $(document).on('click', '[data-toggle="lightbox"]', function (event) {
      event.preventDefault();
      $(this).ekkoLightbox();
    });

    $(window).scroll(function () {
      controlarScroll();
    });

    const parallaxSections = document.querySelectorAll('body.template-landing-v2 .mod-parallax');
    if (parallaxSections.length) {
      const mobileViewport = window.matchMedia('(max-width: 767px)');
      const requestFrame = window.requestAnimationFrame || function (callback) {
        return window.setTimeout(callback, 16);
      };
      let parallaxFrameRequested = false;

      const updateMobileParallax = function () {
        if (parallaxFrameRequested) return;
        parallaxFrameRequested = true;

        requestFrame(function () {
          parallaxFrameRequested = false;

          Array.prototype.forEach.call(parallaxSections, function (section) {
            if (!mobileViewport.matches) {
              section.classList.remove('mobile-parallax');
              section.style.removeProperty('--parallax-image');
              section.style.removeProperty('--parallax-offset');
              return;
            }

            if (!section.classList.contains('mobile-parallax')) {
              section.style.setProperty('--parallax-image', window.getComputedStyle(section).backgroundImage);
              section.classList.add('mobile-parallax');
            }

            const bounds = section.getBoundingClientRect();
            const offset = Math.max(-60, Math.min(60, (bounds.top + bounds.height / 2 - window.innerHeight / 2) * 0.2));
            section.style.setProperty('--parallax-offset', offset + 'px');
          });
        });
      };

      window.addEventListener('scroll', updateMobileParallax, { passive: true });
      window.addEventListener('resize', updateMobileParallax);
      updateMobileParallax();
    }

    function controlarScroll() {

      var objetoMasCercano = null;
      var valorResta = 1000000000000000;

      //console.log($(window).scrollTop());

      $("section[data-etiqueta!='']").each(function () {

        var _href = encodeURIComponent($(this).attr('id'));

        // console.log("**************");
        // console.log($(this).attr('data-etiqueta'));
        // console.log($(this).offset().top+">"+$(window).scrollTop());

        //console.log($(this).scrollTop());
        if ($(this).offset().top >= $(window).scrollTop() && Math.abs($(this).offset().top - $(window).scrollTop()) < valorResta) {
          valorResta = Math.abs($(this).offset().top - $(window).scrollTop());
          objetoMasCercano = $(this);
        }

      });

      $(".mod-sidebar .submenu .indice").removeClass("activo");

      if (objetoMasCercano != null) {
        console.log(objetoMasCercano.attr('data-etiqueta'));

        $(".mod-sidebar .submenu a[href='#" + objetoMasCercano.attr('id') + "']").addClass("activo");

      }

      //console.log($(window).scrollTop());
    }

    $(".js-togglemenu").click(function (e) {
      $(".mod-sidebar .submenu").slideToggle();

    });

    $(".js-menu-ancla").click(function (e) {

      if ($(".js-togglemenu").is(":visible")) {
        $(".mod-sidebar .submenu").slideUp();
      }

    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js